import moment from "moment-timezone";

/** Formats a feature-flag date for table display; empty when missing. */
export default function FormatFeatureFlagDate(value: Date | null | undefined): string {
  if (value == null) {
    return "";
  }

  const local = moment(value).local();
  if (!local.isValid()) {
    return "";
  }

  return local.format("M/D/YYYY h:mm A z");
}
